import React, { Component } from 'react';

import { make_cols } from './MakeColumns';

import './styles.css';

class UploadButtonVendorInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
          file: {},
          data: [],
          cols: []
        }
        this.handleFile = this.handleFile.bind(this);
        this.handleChange = this.handleChange.bind(this);
      }

    handleChange = (e) => {
        const files = e.target.files;
        if (files && files[0]) {
            this.handleFile(files[0]);
        }
        e.target.value = null;
    };

    handleFile(file) {
        /* Boilerplate to set up FileReader */
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;

        let isDC = false;
        let isSKU = false;
        let isVendor = false;
        let isCoreReturnVendor = false;
        let isRecallVendor = false;
        let isWarrantyVendor = false;
        let isUnitsPerCase = false;
        let isCasesPerTier = false;
        let isTiersPerPallet = false;
        let isPOQ = false;
        let isName = false;

        reader.onload = async (e) => {

          const XLSX = await import("xlsx");

          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];

          // Validate headers in exact order
          if(ws.A1 && ws.A1.v === "DC") isDC = true;
          if(ws.B1 && ws.B1.v === "SKU") isSKU = true;
          if(ws.C1 && ws.C1.v === "VENDOR") isVendor = true;
          if(ws.D1 && ws.D1.v === "CORE RETURN VENDOR") isCoreReturnVendor = true;
          if(ws.E1 && ws.E1.v === "RECALL VENDOR") isRecallVendor = true;
          if(ws.F1 && ws.F1.v === "WARRANTY VENDOR") isWarrantyVendor = true;
          if(ws.G1 && ws.G1.v === "UNITS PER CASE") isUnitsPerCase = true;
          if(ws.H1 && ws.H1.v === "CASES PER TIER") isCasesPerTier = true;
          if(ws.I1 && ws.I1.v === "TIERS PER PALLET") isTiersPerPallet = true;
          if(ws.J1 && ws.J1.v === "POQ") isPOQ = true;
          if(ws.K1 && ws.K1.v === "NAME") isName = true;

          if(isDC === false || isSKU === false || isVendor === false || isCoreReturnVendor === false ||
             isRecallVendor === false || isWarrantyVendor === false || isUnitsPerCase === false ||
             isCasesPerTier === false || isTiersPerPallet === false || isPOQ === false || isName === false) {
            return this.props.errorHeader(true);
          }

          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws);
          /* Update state */
          this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
          const excelJson = JSON.parse(JSON.stringify(this.state.data));
          const vendorInfoObject = excelJson.map(({
            "DC": dc,
            "SKU": sku,
            "VENDOR": vendor,
            // CORE RETURN VENDOR, RECALL VENDOR, WARRANTY VENDOR are validated but not extracted
            "UNITS PER CASE": unitsPerCase,
            "CASES PER TIER": casesPerTier,
            "TIERS PER PALLET": tiersPerPallet,
            "POQ": poq,
            "NAME": name
          }) =>
          ({ dc, sku, vendor, unitsPerCase, casesPerTier, tiersPerPallet, poq, name }));
          this.props.onGetExcelData(vendorInfoObject);
         });
        };
        if (rABS) {
          reader.readAsBinaryString(file);
        } else {
          reader.readAsArrayBuffer(file);
        };
    }

    buttonHandler = () => {
        if (this.props.onUploadClick) this.props.onUploadClick();
        document.getElementById('fileInputVendorInfo').click();
    }

    render() {
        return (
            <div style={{ display: 'inline-block' }}>
                <input id="fileInputVendorInfo" type="file" className="input-file" accept=".xls, .xlsx" onChange={this.handleChange}/>
                <input type="button" value="Upload" onClick={this.buttonHandler} className="upload-button"/>
            </div>
        );
    }

}

export default UploadButtonVendorInfo;
